"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignLottery = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var sign_1 = require("../../model/sign");
var service_1 = require("../../../library/base/service");
var SignLottery = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SignLottery, _super);
    function SignLottery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '签到抽奖接口';
        _this.code = '101054';
        _this.desc = '签到抽奖接口';
        _this.requestParams = new sign_1.SignLotteryRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SignLottery;
}(service_1.BaseService));
exports.SignLottery = SignLottery;
//# sourceMappingURL=signLottery.js.map